import { render } from "./CartSticky.vue?vue&type=template&id=0254b26c"
import script from "./CartSticky.vue?vue&type=script&lang=js"
export * from "./CartSticky.vue?vue&type=script&lang=js"

import exportComponent from "/Users/k.belov/Programming/sites/gl_site/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__